import { ListStoreDefault, ListRequestHandler, ListSuccessHandler, ListFilterHandler } from 'js/helpers/reducers.js';

import {
  FETCH_SEARCH_PREVIEW_KEYWORDS,
  FETCHED_SEARCH_PREVIEW_KEYWORDS,
  FETCH_SEARCH_PREVIEW_BRANDS,
  FETCHED_SEARCH_PREVIEW_BRANDS,
  FETCH_SEARCH_PREVIEW_PUBLISHERS,
  FETCHED_SEARCH_PREVIEW_PUBLISHERS,
  FETCH_SEARCH_PREVIEW_OWNED_CONTENT,
  FETCHED_SEARCH_PREVIEW_OWNED_CONTENT,
  FETCH_SEARCH_PREVIEW_PAID_CONTENT,
  FETCHED_SEARCH_PREVIEW_PAID_CONTENT,
  SET_SEARCH_PREVIEW_KEYWORDS_FILTER,
  SET_SEARCH_PREVIEW_BRANDS_FILTER,
  SET_SEARCH_PREVIEW_PUBLISHERS_FILTER,
  SET_SEARCH_PREVIEW_PAID_CONTENT_FILTER,
  SET_SEARCH_PREVIEW_OWNED_CONTENT_FILTER,
  TOGGLE_SEARCH_PREVIEW,
  PREFILL_CONTENT_SEARCH,
  FETCH_ALL_SEARCHES,
  CLEAR_ALL_SEARCHES,
} from 'components/TopBar/actions.js';

const defaultState = {
  keywordsList: ListStoreDefault({
    pageNum: 1,
    pageSize: 30,
    search_by: '',
    searchQuery: '',
  }, { shouldFetch: false }),
  brandsList: ListStoreDefault({
    pageNum: 1,
    pageSize: 10,
    search_by: '',
    searchQuery: '',
  }, { shouldFetch: false }),
  publishersList: ListStoreDefault({
    pageNum: 1,
    pageSize: 10,
    search_by: '',
    searchQuery: '',
  }, { shouldFetch: false }),
  ownedContentList: ListStoreDefault({
    pageNum: 1,
    pageSize: 10,
    searchBy: '',
    searchQuery: '',
    content_type: 'owned',
  }, { shouldFetch: false }),
  paidContentList: ListStoreDefault({
    pageNum: 1,
    pageSize: 10,
    searchBy: '',
    searchQuery: '',
    content_type: 'paid',
  }, { shouldFetch: false }),
  searchQuery: '',
  open: false,
};

const searchByMap = {
  keywordsList: 'value',
  brandsList: 'name',
  publishersList: 'name',
  ownedContentList: 'title',
  paidContentList: 'title',
};

const lists = [
  'paidContentList',
  'ownedContentList',
  'keywordsList',
  'brandsList',
  'publishersList'];

const updateSearchQueryForAll = (state, action) => {
  const newState = { ...state };
  const query = action.searchQuery;
  newState.searchQuery = query;
  lists.map(list => {
    const newListState = { ...state[list] };
    const newFilters = { ...newListState.filters };
    newFilters.searchQuery = query;
    newFilters.searchBy = query.length ? searchByMap[list] : '';
    newFilters.pageNum = 1;
    newListState.filters = newFilters;
    newListState.shouldFetch = true;
    newListState.data = [];
    newListState.pagination = {};
    newState[list] = newListState;
  });
  return newState;
};

const SearchPreviewReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return Object.assign({}, defaultState);
    case TOGGLE_SEARCH_PREVIEW:
      return action.open ? { ...state, open: action.open } : { ...defaultState };
    case FETCH_ALL_SEARCHES:
      return updateSearchQueryForAll(state, action);
    case CLEAR_ALL_SEARCHES:
      return { ...defaultState, searchQuery: action.searchQuery, open: state.open };
    case PREFILL_CONTENT_SEARCH:
      return { ...state, searchQuery: action.searchQuery };
    case FETCH_SEARCH_PREVIEW_KEYWORDS:
      return ListRequestHandler(state, action, 'keywordsList');
    case FETCHED_SEARCH_PREVIEW_KEYWORDS:
      return ListSuccessHandler(state, action, 'keywordsList');
    case SET_SEARCH_PREVIEW_KEYWORDS_FILTER:
      return ListFilterHandler(state, action, 'keywordsList');
    case FETCH_SEARCH_PREVIEW_BRANDS:
      return ListRequestHandler(state, action, 'brandsList');
    case FETCHED_SEARCH_PREVIEW_BRANDS:
      return ListSuccessHandler(state, action, 'brandsList');
    case SET_SEARCH_PREVIEW_BRANDS_FILTER:
      return ListFilterHandler(state, action, 'brandsList');
    case FETCH_SEARCH_PREVIEW_PUBLISHERS:
      return ListRequestHandler(state, action, 'publishersList');
    case FETCHED_SEARCH_PREVIEW_PUBLISHERS:
      return ListSuccessHandler(state, action, 'publishersList');
    case SET_SEARCH_PREVIEW_PUBLISHERS_FILTER:
      return ListFilterHandler(state, action, 'publishersList');
    case FETCH_SEARCH_PREVIEW_OWNED_CONTENT:
      return ListRequestHandler(state, action, 'ownedContentList');
    case FETCHED_SEARCH_PREVIEW_OWNED_CONTENT:
      return ListSuccessHandler(state, action, 'ownedContentList');
    case SET_SEARCH_PREVIEW_OWNED_CONTENT_FILTER:
      return ListFilterHandler(state, action, 'ownedContentList');
    case FETCH_SEARCH_PREVIEW_PAID_CONTENT:
      return ListRequestHandler(state, action, 'paidContentList');
    case FETCHED_SEARCH_PREVIEW_PAID_CONTENT:
      return ListSuccessHandler(state, action, 'paidContentList');
    case SET_SEARCH_PREVIEW_PAID_CONTENT_FILTER:
      return ListFilterHandler(state, action, 'paidContentList');
    default:
      return Object.assign({}, state);
  }
};

export default SearchPreviewReducer;
